import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

const GotoItem = styled.div`
  width: 3rem;
  text-align: center;
  display: grid;
  align-content: center;
  justify-content: center;
  grid-area: goto;
`;

const Chevron = styled.img.attrs({
  src: '/images/chevron.svg',
})`
  color: ${lightGrey2Color};
  width: 0.75rem;
`;

export default () => (
  <GotoItem>
    <Chevron />
  </GotoItem>
);
